import { Injectable } from '@angular/core';
import { HttpSecureClient } from 'path-shared/services/http/httpSecureClient';
import { AuthGuardService } from 'path-shared/services/authentication/auth-guard.service';
import { Observable } from 'rxjs';
import { config } from 'path-shared/configuration/config';
import { api } from 'path-shared/configuration/urls';
import { Tarifa } from '../models/tarifa.model';

const defaultSortParam = 'descripcio';
const defaultSortDirection = 'asc';

@Injectable()
export class TarifesService {
  constructor(private http: HttpSecureClient, private authGuard: AuthGuardService) {}

  getTarifesCombo(): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.get(config.urls['apiUrl'] + api.endpoints['urlGetTarifesCombo'], null);
    }
  }
  setTarifa(tarifa: Tarifa): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.post(config.urls['apiUrl'] + api.endpoints['urlSetTarifa'], tarifa);
    }
  }

  removeTarifa(secure_id): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.delete(config.urls['apiUrl'] + api.endpoints['urlDeleteTarifa'].replace('{secure_id}', secure_id), null);
    }
  }

  removeTimeFrame(secure_id): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.delete(config.urls['apiUrl'] + api.endpoints['urlDeleteTarifaTimeFrame'].replace('{secure_id}', secure_id), null);
    }
  }

  getTarifa(secure_id): Observable<Tarifa> {
    if (this.authGuard.canActivate()) {
      return this.http.getWithType<Tarifa>(config.urls['apiUrl'] + api.endpoints['urlGetTarifa'].replace('{secure_id}', secure_id), null);
    }
  }

  publicar(): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.get(config.urls['apiUrl'] + api.endpoints['urlPublicarTarifa'], null);
    }
  }

  descargarDatos(): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.get(config.urls['apiUrl'] + api.endpoints['urlDescargarDatosTarifa'], null);
    }
  }

  GetData(): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.get(config.urls['apiUrl'] + api.endpoints['urlGetDataTarifes'], null);
    }
  }

  // generateExcel(filter: ColorFilter, sortDir: string, sortField: string): Observable<any> {
  //   const start = 0;
  //   const pageSize = 1000;

  //   sortField = sortField === undefined ? defaultSortParam : sortField;
  //   sortDir = sortDir === '' ? defaultSortDirection : sortDir;
  //   const params = new ColorsFilterService().createFilterParams(filter, start, pageSize, sortField, sortDir);

  //   if (this.authGuard.canActivate()) {
  //     return this.http.getFile(config.urls['apiUrl'] + api.endpoints['urlColorsExcel'],  params );
  //   }
  // }
}
